import React from "react";
import "./Tabs.css";

export default function Tabs({ tabs, active, onChange }) {
  return (
    <div className="mfg-tabs" role="tablist">
      {tabs.map((t) => (
        <button
          key={t.key}
          role="tab"
          type="button"
          aria-selected={active === t.key}
          className={`mfg-tab-btn${active === t.key ? " active" : ""}`}
          onClick={() => onChange(t.key)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
